const n = (a, e) => e === "TenantsCalloutBox" ? Math.max(Math.min(a / 16, 0.6), 0.65) : e === "Thumbnail" || e === "ThumbnailText" ? Math.max(Math.min(a / 16, 0.8), 0.6) : e === "RoadLabel" ? Math.max(Math.min(a / 16, 0.8), 0.35) : e === "Textbox" ? Math.max(Math.min(a / 16, 0.8), 0.6) : 1, s = (a) => a === "TenantsCalloutBox" ? {
  x: 0,
  y: 90
} : a === "RoadLabel" ? {
  x: 0,
  y: 0
} : {
  x: 0,
  y: 50
};
export {
  n as calcCalloutScale,
  s as getDefaultOffset
};
//# sourceMappingURL=index.es252.js.map
